__turbopack_context__.v({
  "SeeMoreBtn": "LoadMore-module__Lmd72a__SeeMoreBtn",
  "bgclr": "LoadMore-module__Lmd72a__bgclr",
  "spin": "LoadMore-module__Lmd72a__spin",
  "spinner": "LoadMore-module__Lmd72a__spinner",
});
